import { Dispatch } from 'redux';
import { Product } from '~domain/product/Product';
import { ProductVideo } from '~domain/product/ProductVideo';
import {
  Product as ProductJson,
  ProductType,
  VideoKey,
} from '~redux/brand/types';
import { request } from '~redux/request/thunk';
import { executeQuery, removeItems } from '~utils/graphql';
import { getPublicImageUrl } from '~utils/image';
import {
  getPublishedProduct,
  getPublishedProductPreview,
  getPublishedProductUnAuth,
} from '../../../graphql/custom_queries';
import { getProductStart, getSignedProductStart, setProduct } from '../actions';

export const getSignedProduct = (product: ProductJson) => {
  return async (dispatch: Dispatch) => {
    dispatch(getSignedProductStart());

    const signedPosts = [
      ...product.imageKeys.map((item: any) => {
        const signedUrl = getPublicImageUrl(item.imageKey);
        item.imageUrl = signedUrl;
        return item;
      }),
    ];

    const signedTypes = product.producttype.map((item: any) => {
      if (!item) {
        return;
      }
      const signedUrl = item.imageKey ? getPublicImageUrl(item.imageKey) : null;
      item.imageUrl = signedUrl;
      return item;
    });

    const signedProduct = {
      ...product,
      imageKeys: signedPosts,
      producttype: signedTypes,
    };

    dispatch(setProduct(signedProduct));
  };
};

export const getProduct = (id: string, unAuth?: boolean, preview?: boolean) => {
  return async (dispatch: Dispatch<any>) => {
    const productData = await executeQuery(
      unAuth
        ? getPublishedProductUnAuth
        : preview
        ? getPublishedProductPreview
        : getPublishedProduct,
      { id },
      unAuth
    );
    // console.log(productData);

    const {
      data: { getProduct: product },
    } = productData;

    if (!product) {
      return;
    }

    const productModel = await Product.create({
      ...removeItems(product),
      discount: product.discount,
      collections: product.collections,
      videos: await Promise.all(
        product.videoKeys.items.map((videoKey: VideoKey) =>
          ProductVideo.createByVideoKey({
            videoKey: videoKey.videoKey,
            uid: videoKey.videoKey.replace(/\.[^.]+$/, ''),
            product_brand_id: product.product_brand_id,
            product_id: product.id,
            product_owner: product.product_owner,
          })
        )
      ),
      producttype: product?.producttype?.items?.filter(
        (item: ProductType) => !item.suspended
      ),
      brand: {
        ...(product.brand ?? {}),
        reviews: product.brand?.reviews,
      },
    });

    const signedImages = [
      ...productModel.imageKeys.map((item: any) => {
        const signedUrl = getPublicImageUrl(item.imageKey);
        item.imageUrl = signedUrl;
        return item;
      }),
    ];

    const signedTypes = productModel.producttype.map((item: any) => {
      if (!item) {
        return;
      }
      const signedUrl = item.imageKey ? getPublicImageUrl(item.imageKey) : null;
      item.imageUrl = signedUrl;
      return item;
    });

    const signedProduct = {
      ...productModel,
      imageKeys: signedImages,
      producttype: signedTypes,
    };

    dispatch(setProduct(signedProduct));
  };
};
